module.exports = __webpack_public_path__ + "static/img/1earth1.612ca746.png";